import React from 'react';
import UIAvatarImage from '@/components/shared/UIAvatarImage';
import './UITenantInfo.scss';

export interface UITenantInfoProps {
  name: string;
  email: string;
  tenantId: number; // Повернули для сумісності та усунення помилок
  avatar?: string | null;
  size?: 'small' | 'medium' | 'large';
  className?: string;
  onClick?: () => void;
}

const baseClass = 'UITenantInfo';

const UITenantInfo: React.FC<UITenantInfoProps> = ({
                                                     name,
                                                     email,
                                                     tenantId,
                                                     avatar,
                                                     size = 'medium',
                                                     className = '',
                                                     onClick
                                                   }) => {

  const containerClasses = [
    baseClass,
    `${baseClass}--${size}`,
    onClick && `${baseClass}--clickable`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} onClick={onClick}>
      <div className={`${baseClass}__photo`}>
        <UIAvatarImage
          avatar={avatar}
          size={size}
          alt={name}
        />
      </div>
      <div className={`${baseClass}__info`}>
        <div className={`${baseClass}__name`}>{name}</div>
        <div className={`${baseClass}__email`}>{email}</div>
      </div>
    </div>
  );
};
export default UITenantInfo;